import { useReducer } from "react";
import { useAppContext } from "context/app-context";
import { useCartContext } from "context/cart-context";
import { useNavigate } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";
import { setReturnToCookie } from "services/cookies";
import { INITIAL_CARD_AMOUNT_STATE } from "./constants";
import { cardAmountReducer } from "./reducers";

export const useHandleGroupedRowValue = () => {
  const [state, dispatch] = useReducer(
    cardAmountReducer,
    INITIAL_CARD_AMOUNT_STATE
  );
  const { addMultipleCards } = useCartContext();
  const navigate = useNavigate();
  const {
    sessionInfo: { isLoggedIn, userID }
  } = useAppContext();

  const handleAddToCart = async ({
    brandSlug,
    value,
    discount,
    price,
    productSourceId
  }) => {
    if (!isLoggedIn) {
      setReturnToCookie(window.location.href);
      navigate(INTERNAL_PATHS.USER_LOG_IN);
      throw new Error("User should be authenticated to add an item to cart.");
    }

    await addMultipleCards({
      groupedListingEnabled: true,
      slug: brandSlug,
      value,
      quantity: state.value,
      discount,
      price,
      userID,
      productSourceId
    });
  };

  return {
    handleAddToCart,
    cardAmount: state.value,
    handleCardAmount: dispatch
  };
};
